import React from "react";
import { Stack } from "@mui/material";
import { ShowWhen } from "../ShowWhen";
import { FertigationRate } from "../../types";

interface FmFertigationRateProps {
    rate: FertigationRate | null;
}

const boxes: { color: string }[] = [
    {
        color: "#006543",
    },
    {
        color: "#369946",
    },
    {
        color: "#FDEE21",
    },
    {
        color: "#F48221",
    },
    {
        color: "#C9252C",
    },
];

export const FmFertigationRate = (props: FmFertigationRateProps) => {
    if (props.rate === null) {
        return <></>;
    }

    return (
        <Stack direction='row' alignItems='flex-end' gap='18px'>
            <span>Excellent</span>

            <Stack direction='row'>
                {boxes.map((e, idx) => (
                    <CustomBox key={e.color.length + "_" + e.color} color={e.color} isActive={idx + 1 === props.rate} />
                ))}
            </Stack>

            <span>Worse</span>
        </Stack>
    );
};

interface BoxProps {
    isActive: boolean;
    color: string;
}

const CustomBox = (props: BoxProps) => {
    return (
        <Stack direction='column' alignItems='center' gap='4px'>
            <div
                style={{
                    height: 16,
                }}
            >
                <ShowWhen when={props.isActive}>
                    <Arrow color={props.color} />
                </ShowWhen>
            </div>

            <div
                style={{
                    backgroundColor: props.color,
                    width: 30,
                    height: 30,
                    border: props.isActive ? "1.5px solid #353535" : "",
                }}
            />
        </Stack>
    );
};

const Arrow = (props: { color: string }) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='22' height='9' viewBox='0 0 22 9' fill='none'>
            <path d='M11 9L0.607694 -5.0249e-08L21.3923 1.7668e-06L11 9Z' fill={props.color} />
        </svg>
    );
};
